module.exports = __webpack_public_path__ + "img/zhuan-ben.1840f048.png";